export default __webpack_public_path__ + "static/media/business_headshot.af1ad861.jpg";